export function obterHardware() {
  return {
    ramGB: navigator.deviceMemory ?? null,
    nucleosLogicos: navigator.hardwareConcurrency ?? null,
    navegador: navigator.userAgent,
    plataforma: navigator.platform
  };
}
